import { SocialMediaShare } from "@components/SocialMediaShare/SocialMediaShare";
import { CMSBlock } from "@jwm/types/CMSBlock";
import React from "react";

interface SocialMediaSharingOptionsBlockProps {
    content: CMSBlock["social_media_sharing_options"];
    placement?: string;
}

export const SocialMediaSharingOptionsBlock = ({
    content,
    placement,
}: SocialMediaSharingOptionsBlockProps): JSX.Element => (
    <SocialMediaShare socialmediadata={content} placement={placement} />
);
